export const SET_BO_SEARCH_PARAMETERS = 'SET_BO_SEARCH_PARAMETERS'
export const SET_BO_SEARCH_RESULTS_PAGE = 'SET_BO_SEARCH_RESULTS_PAGE'
export const CLEAR_BO_SEARCH_ERRORS = 'CLEAR_BO_SEARCH_ERRORS'
export const SET_PAGINATED_ROW_COUNTS = 'SET_PAGINATED_ROW_COUNTS'
export const SET_BO_CSV_SEARCH_RESULTS = 'SET_BO_CSV_SEARCH_RESULTS'
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE'
export const SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE'
export const SET_SERVER_PAGINATION = 'SET_SERVER_PAGINATION'
export const SET_STAFF_SEARCH_JSON = 'SET_STAFF_SEARCH_JSON'
export const SET_LAST_SEARCH_INFO = 'SET_LAST_SEARCH_INFO'
export const SET_MISC_SEARCH_TEMPLATE = 'SET_MISC_SEARCH_TEMPLATE'

export const initialState = {
  error: false,
  errorDetails: {
    code: null,
    message: null,
  },
  items: null,
  searchResults: {},
  csvSearchResults: {},
  page: 0,
  serverPage: {},
  rowsPerPage: 10,
  serverPagination: {},
  paginatedRowCounts: {},
  searchParameters: { giggles: 'biscuit' },
  searchJson: [],
  lastSearchName: null,
  lastUsedParameters: {},
  miscSearchTemplates: {},
}

const BOSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_WORKVIEW_STATE':
      return initialState
    case 'SET_BO_SEARCH_RESULTS':
      return {
        ...state,
        searchResults: { ...state.searchResults, [action.searchName]: action.items },
      }
    case 'SET_BO_CSV_SEARCH_RESULTS':
      return {
        ...state,
        csvSearchResults: { ...state.csvSearchResults, [action.searchName]: action.items },
      }
    case 'SET_BO_SEARCH_ERROR':
      return {
        ...state,
        error: action.error,
      }
    case 'SET_BO_SEARCH_ERROR_DETAILS':
      return {
        ...state,
        errorDetails: action.errorDetails,
      }
    case '@@bo/INVALIDATE_CACHE':
      return {
        ...state,
        selected: {},
        selectedDetails: null,
        selectedIndex: null,
      }
    case SET_BO_SEARCH_PARAMETERS:
      return { ...state, searchParameters: action.searchParameters }
    case SET_BO_SEARCH_RESULTS_PAGE:
      return {
        ...state,
        page: action.page,
      }
    case CLEAR_BO_SEARCH_ERRORS: {
      return {
        ...state,
        error: false,
        errorDetails: null,
      }
    }
    case SET_PAGINATED_ROW_COUNTS: {
      return {
        ...state,
        paginatedRowCounts: { ...state.paginatedRowCounts, [action.searchName]: action.rowCount },
      }
    }
    case SET_SERVER_PAGE: {
      return {
        ...state,
        serverPage: {
          ...state.serverPage,
          [action.searchName]: action.serverPage,
        },
      }
    }
    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        rowsPerPage: action.newPageSize,
      }
    }
    case SET_SERVER_PAGINATION: {
      return {
        ...state,
        serverPagination: {
          ...state.serverPagination,
          [action.searchName || 'none']: action.isServerPaginated,
        },
      }
    }
    case SET_STAFF_SEARCH_JSON: {
      return {
        ...state,
        searchJson: action.searchJson,
      }
    }
    case SET_LAST_SEARCH_INFO: {
      return {
        ...state,
        lastSearchName: action.lastSearchName,
        lastUsedParameters: action.lastUsedParameters,
      }
    }
    case SET_MISC_SEARCH_TEMPLATE: {
      return {
        ...state,
        miscSearchTemplates: { ...state.miscSearchTemplates, [action.searchTitle]: action.template },
      }
    }
    default:
      return state
  }
}

export default BOSearchReducer
